import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../assets/favicon.ico";
import {
  resetPasswordRequestAsync,
  selectMailSend,
} from "../features/auth/authSlice";
const ForgetPassword = () => {
  const dispatch = useDispatch();
  const mailSend = useSelector(selectMailSend);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  return (
    <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <img className="mx-auto w-16" src={logo} alt="Your Company" />
        <h2 className="mt-2 text-center text-2xl font-extrabold leading-1 tracking-tighter font-bolder text-gray-900 uppercase font-Oswald">
          Reset Password
        </h2>
        <p className="text-sm tracking-wider text-center opacity-75 leading-5 my-4 ">
          Enter your email to receive instructions on how to <br /> reset your
          password.
        </p>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form
          className="space-y-6"
          noValidate
          onSubmit={handleSubmit((data) => {
            dispatch(resetPasswordRequestAsync(data.email));
          })}
        >
          <div>
            <div className="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                {...register("email", {
                  required: "Email required",
                  pattern: {
                    value: /\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/gi,
                    message: "Please enter a valid email",
                  },
                })}
                autoComplete="email"
                placeholder="Email address"
                required
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
              />
              {errors.email && (
                <p className="text-red-500">{errors.email.message}</p>
              )}
              {mailSend && (
                <p className="text-green-500">
                  Verification mail is send , Please check your email
                </p>
              )}
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="flex uppercase font-Oswald tracking-tighter w-full justify-center rounded-sm bg-black px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Send Verification mail
            </button>
          </div>
        </form>

        <p className="mt-4 text-center text-sm text-gray-500">
          Or return to
          <Link
            to="/login"
            className="font-semibold leading-6 text-blackunderline underline"
          >
            Login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgetPassword;
